import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getAuthToken } from "../utils/api";

const PrivateRoute = ({ exact, component: Component, ...rest }) => {
  const authToken = getAuthToken();

  return (
    <Route
      exact={exact ? true : false}
      {...rest}
      render={(props) =>
        authToken ? (
          <Component {...props} {...rest}></Component>
        ) : (
          <Redirect to={`${process.env.PUBLIC_URL}/auth-login`}></Redirect>
        )
      }
    ></Route>
  );
};

export default PrivateRoute;
